import React from 'react';
import commonUtils from '../../../../utils/commonUtils';
import RouteConfig from '../../../config/routeConfig';
import ABSLink from '../../../../components/ABSLink';
import './index.less';
import authService from '../../../services/auth/authService';
import { shareHtmlType } from '../../../../components/ABSShare/util';

function renderLinkProductDealInfo(text: any, record: any) {
  if (record.deal_id) {
    return (
      <ABSLink target="_blank" to={`${RouteConfig.productDealInfo + record.deal_id}`}>
        {commonUtils.formatContent(text)}
      </ABSLink>
    );
  }
  return (
    <span>
      {commonUtils.formatContent(text)}
    </span>
  );
}

// 一级市场-近7日发行
export function getFirstMarketIssueColumns() {
  // 设置列表
  const columnsFirstMarketIssue = [
    {
      title: '产品全称',
      dataIndex: 'deal_name',
      key: 'deal_name',
      className: 'abs-left abs-daily-first-market-w460',
      render: (text, record) => renderLinkProductDealInfo(text, record)
    }, {
      title: '发行日期',
      dataIndex: 'date',
      key: 'date',
      className: 'abs-left abs-daily-first-market-second-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      }
    }, {
      title: '场所',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'abs-left abs-daily-first-market-third-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      } 
    }, {
      title: '金额(亿)',
      dataIndex: 'amount',
      key: 'amount',
      className: 'abs-right abs-daily-first-market-fourth-col',
      render: (text, record) => {
        return commonUtils.formatContent(text, true, false, true, 2, 8);
      } 
    }
  ];
  return columnsFirstMarketIssue;
}

// 一级市场-近7日审批
export function getFirstMarketRefreshColumns() {
  const columnsFirstMarketRefresh = [
    {
      title: '产品全称',
      dataIndex: 'deal_name',
      key: 'deal_name',
      className: 'abs-left abs-daily-first-market-w460',
      render: (text, record) => renderLinkProductDealInfo(text, record)
    }, {
      title: '更新日期',
      dataIndex: 'date',
      key: 'date',
      className: 'abs-left abs-daily-first-market-second-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      }
    },  {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      className: 'abs-left abs-daily-first-market-third-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      } 
    }, {
      title: '场所',
      dataIndex: 'exchange',
      key: 'exchange',
      className: 'abs-left abs-daily-first-market-fourth-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      } 
    }
  ];
  return columnsFirstMarketRefresh;
}

// 一级市场-未来簿记建档
export function getFirstMarketRemarkColumns() {
  // 设置列表
  const columnsFirstMarketRemark = [
    {
      title: '产品全称',
      dataIndex: 'deal_name',
      key: 'deal_name',
      className: 'abs-left abs-daily-first-market-w460',
      render: (text, record) => renderLinkProductDealInfo(text, record)
    }, {
      title: '簿记建档日',
      dataIndex: 'closing_date',
      key: 'closing_date',
      className: 'abs-left abs-daily-first-market-second-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      } 
    }, {
      title: '产品分类',
      dataIndex: 'product_type',
      key: 'product_type',
      className: 'abs-left abs-daily-first-market-third-col',
      render: (text, record) => {
        return commonUtils.formatContent(text);
      }
    }, {
      title: '金额(亿)',
      dataIndex: 'amount',
      key: 'amount',
      className: 'abs-right abs-daily-first-market-fourth-col',
      render: (text, record) => {
        return commonUtils.formatContent(text, true, false, true, 2, 8);
      } 
    }
  ];
  return columnsFirstMarketRemark;
}

enum NumberType {
  TOBEISSUED = 'TOBEISSUED', // 待发行单数
  YEARISSUED = 'YEARISSUED',  // 今年发行单数
  HISISSUED = 'HISISSUED',  // 历史累计单数
  SUBSIST = 'SUBSIST',  // 存续单数
}

export function getDistributionStatisticsListColumns() {
  const nowDate = new Date().getFullYear();
  
  // 设置列ProductTypeSimple
  const columnsDistributionStatistics = [
    {
      title: '',
      children: [
        {
          title: '类别',
          dataIndex:  'ProductType',
          key: 'ProductType',
          className: 'abs-left abs-product-type',
          render: (text, record) => {
            if (record.ProductTypeId === '0') {
              return <ABSLink to={`${RouteConfig.productCategory}`} title="跳转至细分市场" >{commonUtils.formatContent(text, true, false, true, 0)}</ABSLink>;
            } else {
              return <ABSLink to={`${RouteConfig.productCategory}?product_type_id=${record.ProductTypeId}&asset_type_id=0&asset_sub_type_id=0`} title="跳转至细分市场">{commonUtils.formatContent(text, true, false, true, 0)}</ABSLink>;
            }
          }
        },
      ]
    },
    {
      title: `${nowDate}年发行`,
      children: [
        {
          title: '单数',
          dataIndex: 'DealCountCurryear',
          key: 'DealCountCurryear',
          className: 'abs-right distri-stats-column',
          render: (text, record) => renderNumLink(text, record, NumberType.YEARISSUED)
        },
        {
          title: '金额(亿)',
          dataIndex: 'TotalOfferingCurryear',
          key: 'TotalOfferingCurryear',
          className: 'abs-right distri-stats-column',
          render: (text) => commonUtils.formatContent(text, true, false, true, 2, 8)
        },
      ]
    },
    {
      title: '历史累计',
      children: [
        {
          title: '单数',
          dataIndex: 'DealCount',
          key: 'DealCount',
          className: 'abs-right distri-stats-column',
          render: (text, record) => renderNumLink(text, record, NumberType.HISISSUED)
        },
        {
          title: '金额(亿)',
          dataIndex: 'TotalOffering',
          key: 'TotalOffering',
          className: 'abs-right distri-stats-column',
          render: (text) => commonUtils.formatContent(text, true, false, true, 2, 8)
        },
      ]
    }
  ];
  let extraCol = {
    title: '待发行单数',
    dataIndex: 'IssueOfCount',
    key: 'IssueOfCount',
    className: 'abs-right distri-stats-column',
    render: (text, record) => renderNumLink(text, record, NumberType.TOBEISSUED)
  };
  columnsDistributionStatistics[1].children.unshift(extraCol);
  
  return columnsDistributionStatistics;
}

function renderNumLink (text: any, record: any, numberType: any) {
  let addFilter = '';
  let key = 0;
  if (numberType === NumberType.TOBEISSUED) {
    // [待发行单数] - 发行期
    addFilter = `filter_query_list[${key}][key]=11&filter_query_list[${key}][value][0]=16`;
    addFilter += `&is_select_date=true`;
    key++;
  } else if (numberType === NumberType.YEARISSUED) {
    // [今年发行单数] - 存续期，已清算
    addFilter = `filter_query_list[${key}][key]=11&filter_query_list[${key}][value][0]=13&filter_query_list[${key}][value][1]=14`;
    key++;
    const nowYear = new Date().getFullYear();
    addFilter += `&filter_query_list[${key}][key]=7&filter_query_list[${key}][value][0]=${nowYear}`;
    key++;
  } else if (numberType === NumberType.HISISSUED) {
    // [历史累计单数] - 存续期，已清算
    addFilter = `filter_query_list[${key}][key]=11&filter_query_list[${key}][value][0]=13&filter_query_list[${key}][value][1]=14`;
    addFilter += `&use_today=true`;
    key++;
  } else if (numberType === NumberType.SUBSIST) {
    // [存续单数]  - 存续期
    addFilter = `filter_query_list[${key}][key]=11&filter_query_list[${key}][value][0]=13`;
    addFilter += `&use_today=true`;
    key++;
  }

  if (record.ProductTypeId === '0') {
    return <ABSLink to={`${RouteConfig.productList}?${addFilter}`} title="跳转至产品列表">{commonUtils.formatContent(text, true, false, true, 0)}</ABSLink>;
  } else {
    return <ABSLink to={`${RouteConfig.productList}?${addFilter}&filter_query_list[${key}][key]=4&filter_query_list[${key}][value][0]=${record.ProductTypeId}`} title="跳转至产品列表">{commonUtils.formatContent(text, true, false, true, 0)}</ABSLink>;
  }
}

export function QRShareAddPoint(dispatch: any, htmlType: any, userId?: string) {
  let userid;
  if (userId) {
    userid = userId;
  } else {
    const user = authService.getCurrentUser();
    userid = user ? user.id : '';
  }
  const htmlTypeNew = htmlType ? htmlType : shareHtmlType.dailyReport;
  dispatch({
    type: 'global/shareAddPoint', 
    payload: { user_id: userid, type: htmlTypeNew }
  });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/market/DailyReport/utils.tsx